import { Foundry_FoundryMasterTourSteps } from "../../components/TourGuide/tourGuideData";
import { useEffect, useRef, useState } from "react";
import FoundryForm from "./FoundryForm";
import Table from "../../common/Table";
import { foundry } from "../../utlis/apiService";
import { notify } from "../../common/Toast";
import Pagination from "../../common/Pagination";
import ConfirmDeleteModal from "../../common/DeleteModel";
import Loader from "../../common/Loader";
import { HiOutlinePlus } from "react-icons/hi";
import { RegistryHeader, Button } from "../../common/Shared";
import { formatDate } from "../../utlis/formateDate";
import { LiaSearchSolid } from "react-icons/lia";
import { MdClose } from "react-icons/md";
import dayjs from "dayjs";
import { TourGuide } from "../../components/TourGuide/TourGuide";
import { Info } from "lucide-react";

const Foundry = () => {
  const user = JSON.parse(sessionStorage.getItem("user"));
  const userId = user?.userId;
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isFoundryData, setIsFoundryData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isSaving, setIsSaving] = useState(false);
  const pageSize = 20;
  const [formData, setFormData] = useState({
    foundryEntry: {
      CASTING_NO: 0,
      CASTING_DATE: "",
      IN_CHARGE_ID: "",
      LDO_PRE_HEATING_LEVEL: "",
      LDO_CHARGING_START_LEVEL: "",
      LDO_CATING_TIME_LEVEL: "",
      LDO_MAIN_TANK_OPENING_LEVEL: "",
      LDO_MAIN_TANK_CLOSING_LEVEL: "",
      LDO_TOTAL_CONSUMPTION: "",
      ALLOY_GRAD: "",
      HLINE_GRAD: "",
      NO_OF_LOGS: "",
      LOG_LENGTH: "",
      LOG_WEIGHT: "",
      TOTAL_OUTPUT_WEIGHT: "",
      REMARK: "",
      CREATED_BY: userId,
    },
    scrapEntries: [
      { CASTING_NO: "", INWARD_NO: "", QUANTITY: "", CREATED_BY: userId },
    ],
    otherMetalEntries: [
      {
        CASTING_NO: "",
        INGOT: "",
        PLANT_SCRAP: "",
        PLANT_DISCARD: "",
        DROSS_INGOT: "",
        BEND_LOG: "",
        HILL_METAL: "",
        PIT_METAL: "",
        TENDIS_METAL: "",
        DROSS_METAL: "",
        TOTAL_WEIGHT: "",
        CREATED_BY: userId,
      },
    ],
    furnaceEntries: [
      {
        FURNACE_NO: 0,
        PRE_HEATED: false,
        CHARGING_START_TIME: "",
        CHARGING_END_TIME: "",
        CASTING_START_TIME: "",
        CASTING_END_TIME: "",
        TOTAL_TIME: "",
        CREATED_BY: userId,
      },
    ],
    byProductEntries: [
      {
        DROSS: "",
        ALUMINIUM_METAL_REUSABLE: "",
        IRON: "",
        DROSS_INGOT: "",
        PIT_METAL: "",
        HILL_METAL: "",
        TENDIS_METAL: "",
        BURNING_LOSS: "",
        CREATED_BY: userId,
      },
    ],
    chemicalEntries: [
      { MATERIAL_ID: "", QUANTITY: "", STOCK: "", CREATED_BY: userId },
    ],
    finalSpectroEntries: [
      { Components_Id: "", Components_Value: "", CREATED_BY: userId },
    ],
    sampleSpectroEntries: [
      { Components_Id: "", Components_Value: "", CREATED_BY: userId },
    ],
  });
  const [isEditing, setIsEditing] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const isFetchingRef = useRef(false);
  const tableScrollRef = useRef(null);
  const [searchTerm, setSearchTerm] = useState("");

  const [isTourOpen, setIsTourOpen] = useState(false);

  useEffect(() => {
    const hasSeenTour = localStorage.getItem("aluex_foundry_tour_seen");
    if (!hasSeenTour) {
      const timer = setTimeout(() => {
        setIsTourOpen(true);
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleTourComplete = () => {
    localStorage.setItem("aluex_foundry_tour_seen", "true");
  };



  const fetchFoundryData = async () => {
    setLoading(true);
    try {
      const res = await foundry.getAllFoundry(currentPage, pageSize);
      if (currentPage === 1) {
        setIsFoundryData(res.items || []);
      } else {
        setIsFoundryData((prev) => [...prev, ...(res.items || [])]);
      }

      if (!res.items || res.items.length < pageSize) {
        setHasMore(false);
      } else {
        setHasMore(true);
      }

      isFetchingRef.current = false;
    } catch (error) {
      notify("Error fetching foundry data", "error");
    }
    setLoading(false);
  };

  useEffect(() => {
    const el = tableScrollRef.current;
    if (!el) return;

    const onScroll = () => {
      if (loading || !hasMore || isFetchingRef.current) return;

      const { scrollTop, clientHeight, scrollHeight } = el;

      if (scrollHeight - scrollTop <= clientHeight + 100) {
        isFetchingRef.current = true;
        setCurrentPage((p) => p + 1);
      }
    };

    el.addEventListener("scroll", onScroll);
    return () => el.removeEventListener("scroll", onScroll);
  }, [loading, hasMore]);

  useEffect(() => {
    fetchFoundryData();
  }, [currentPage]);

  const normalizeFoundryData = (data) => {
    return {
      foundryEntry: {
        ...data.foundryEntry,
        CASTING_NO: data.foundryEntry.castinG_NO,
        CASTING_DATE: data.foundryEntry.castinG_DATE.split("T")[0],
        IN_CHARGE_ID: data.foundryEntry.iN_CHARGE_ID,
        FURNACE_ID: data.foundryEntry.furnacE_ID,
        LDO_PRE_HEATING_LEVEL: data.foundryEntry.ldO_PRE_HEATING_LEVEL,
        LDO_CHARGING_START_LEVEL: data.foundryEntry.ldO_CHARGING_START_LEVEL,
        LDO_CHARGING_END_LEVEL: data.foundryEntry.ldO_CHARGING_END_LEVEL,
        LDO_MAIN_TANK_OPENING_LEVEL:
          data.foundryEntry.ldO_MAIN_TANK_OPENING_LEVEL,
        LDO_MAIN_TANK_CLOSING_LEVEL:
          data.foundryEntry.ldO_MAIN_TANK_CLOSING_LEVEL,
        LDO_PRE_HEATING_CONSUMPTION:
          data.foundryEntry.ldO_PRE_HEATING_CONSUMPTION,
        LDO_FURNACE_CONSUMPTION: data.foundryEntry.ldO_FURNACE_CONSUMPTION,
        LDO_TOTAL_CONSUMPTION: data.foundryEntry.ldO_TOTAL_CONSUMPTION,
        LDO_DIESEL_OPENING_LEVEL: data.foundryEntry.ldO_DIESEL_OPENING_LEVEL,
        LDO_DIESEL_CLOSING_LEVEL: data.foundryEntry.ldO_DIESEL_CLOSING_LEVEL,
        ALLOY_GRAD: data.foundryEntry.alloY_GRAD,
        HLINE_GRAD: data.foundryEntry.hlinE_GRAD,
        NO_OF_LOGS: data.foundryEntry.nO_OF_LOGS,
        LOG_LENGTH: data.foundryEntry.loG_LENGTH,
        LOG_WEIGHT: data.foundryEntry.loG_WEIGHT,
        TOTAL_OUTPUT_WEIGHT: data.foundryEntry.totaL_OUTPUT_WEIGHT,
        REMARK: data.foundryEntry.remark,
        CREATED_BY: data.foundryEntry.createD_BY,
      },
      scrapEntries: data.scrapEntries.map((s) => ({
        Inward_No: s.inward_No,
        QUANTITY: s.quantity,
        CASTING_NO: s.castinG_NO,
        SEQ_NO: s.seq_No,
        CREATED_BY: s.createD_BY,
      })),
      scrapTotal: Number(data.scrapTotal || 0),
      otherMetalEntries: data.otherMetalEntries.map((o) => ({
        CASTING_NO: o.castinG_NO,
        INGOT: o.ingot,
        PLANT_SCRAP: o.planT_SCRAP,
        PLANT_DISCARD: o.planT_DISCARD,
        DROSS_INGOT: o.drosS_INGOT,
        BEND_LOG: o.benD_LOG,
        HILL_METAL: o.hilL_METAL,
        PIT_METAL: o.piT_METAL,
        TENDIS_METAL: o.tendiS_METAL,
        DROSS_METAL: o.drosS_METAL,
        TOTAL_WEIGHT: o.totaL_WEIGHT,
        CREATED_BY: o.createD_BY,
      })),
      furnaceEntries: data.furnaceEntries.map((f) => {
        const formatTime = (isoStr) => {
          if (!isoStr) return "";
          return dayjs(isoStr).format("HH:mm");
        };
        return {
          FURNACE_NO: f.furnacE_NO,
          PRE_HEATED: f.prE_HEATED,
          PRE_HEATING_START_TIME: formatTime(f.prE_HEATING_START_TIME),
          CHARGING_START_TIME: formatTime(f.charginG_START_TIME),
          CHARGING_END_TIME: formatTime(f.charginG_END_TIME),
          CASTING_START_TIME: formatTime(f.castinG_START_TIME),
          CASTING_END_TIME: formatTime(f.castinG_END_TIME),
          TOTAL_TIME: f.totaL_TIME,
          CREATED_BY: f.createD_BY,
        };
      }),
      byProductEntries: data.byProductEntries.map((b) => ({
        DROSS: b.dross,
        ALUMINIUM_METAL_REUSABLE: b.aluminiuM_METAL_REUSABLE,
        IRON: b.iron,
        DROSS_INGOT: b.drosS_INGOT,
        PIT_METAL: b.piT_METAL,
        HILL_METAL: b.hilL_METAL,
        TENDIS_METAL: b.tendiS_METAL,
        BURNING_LOSS: b.burninG_LOSS,
        CREATED_BY: b.createD_BY,
      })),
      chemicalEntries: data.chemicalEntries.map((c) => ({
        MATERIAL_ID: c.materiaL_ID,
        qty: c.quantity,
        stock: c.availablE_QUANTITY,
        SEQ_NO: c.seQ_NO,
        CREATED_BY: c.createD_BY,
      })),
      sampleSpectroEntries: data.sampleSpectroEntries.map((s) => ({
        componentId: s.components_Id,
        percentage: s.components_Value,
        SEQ_NO: s.seq_No,
        Created_By: s.created_By,
      })),
      finalSpectroEntries: data.finalSpectroEntries.map((f) => ({
        componentId: f.components_Id,
        percentage: f.components_Value,
        SEQ_NO: f.seq_No,
        Created_By: f.created_By,
      })),
    };
  };

  const handleEdit = async (id) => {
    setLoading(true);
    try {
      const rawData = await foundry.getById(id);
      const normalizedData = normalizeFoundryData(rawData);
      setFormData(normalizedData);
      setIsEditing(true);
      setIsModelOpen(true);
    } catch (error) {
      notify("Failed to fetch foundry details", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = (id) => {
    setSelectedId(id);
    setIsDeleteModalOpen(true);
  };

  const handleConfirmDelete = async () => {
    setLoading(true);
    try {
      await foundry.delete(selectedId);
      notify("Deleted successfully", "success");
      fetchFoundryData();
    } catch (error) {
      notify("Failed to delete record", "error");
    } finally {
      setIsSaving(false);
      setIsDeleteModalOpen(false);
      setSelectedId(null);
      setLoading(false);
    }
  };

  const handleSave = async (payload, castingNo, files) => {
    setIsSaving(true);
    try {
      const response = await foundry.saveOrUpdate(payload);

      // --- Upload Spectro Files by Casting No ---
      const savedCastingNo =
        response?.foundryEntry?.castinG_NO || payload?.foundryEntry?.CASTING_NO;

      if (savedCastingNo) {
        // Sample Spectro File
        if (files?.sampleSpectroFile) {
          const sampleFormData = new FormData();
          sampleFormData.append("file", files.sampleSpectroFile);
          sampleFormData.append("CastingNo", savedCastingNo);
          await foundry.uploadSampleFile(sampleFormData);
        }

        // Final Spectro File
        if (files?.finalSpectroFile) {
          const finalFormData = new FormData();
          finalFormData.append("file", files.finalSpectroFile);
          finalFormData.append("CastingNo", savedCastingNo);
          await foundry.uploadFinalFile(finalFormData);
        }
      }

      notify("Saved successfully", "success");
      fetchFoundryData();
      setIsModelOpen(false);
      setFormData(null);
      setIsEditing(false);
    } catch (error) {
      notify("Failed to save foundry log", "error");
    } finally {
      setIsSaving(false);
    }
  };

  if (isModelOpen) {
    return (
      <FoundryForm
        onSave={handleSave}
        onCancel={() => {
          setIsModelOpen(false);
          setFormData(null);
          setIsEditing(false);
        }}
        initialData={formData}
        isEditing={isEditing}
        isSaving={isSaving}
      />
    );
  }

  return (
    <div className="flex flex-col h-full bg-white font-plus relative">
      {loading && <Loader centered />}
      <RegistryHeader
        title="Foundry Activity Registry"
      >
        <div className="flex items-center gap-2">
          <button
            onClick={() => setIsTourOpen(true)}
            className="hidden md:flex items-center gap-2 px-3 py-2 bg-slate-50 hover:bg-slate-100 text-slate-500 border border-slate-200 text-[10px] font-black uppercase tracking-[1.5px] transition-colors"
            title="Page Guide"
          >
            <Info size={14} />
            Guide
          </button>
        </div>
        <div className="relative w-full sm:w-80 group" data-tour="foundry-search">
          <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none group-focus-within:text-primary">
            <LiaSearchSolid size={18} className="text-gray-400 transition-colors" />
          </div>
          <input
            type="text"
            placeholder="Search Logs..."
            className="block w-full pl-12 pr-10 py-2.5 bg-gray-50 border border-gray-200 text-gray-900 text-[11px] font-black uppercase tracking-[2px] focus:border-primary focus:bg-white focus:outline-none transition-all placeholder:text-gray-300"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          {searchTerm && (
            <button
              onClick={() => setSearchTerm("")}
              className="absolute inset-y-0 right-0 pr-4 flex items-center text-gray-400 hover:text-red-500 transition-colors"
            >
              <MdClose size={18} />
            </button>
          )}
        </div>

        <div data-tour="foundry-add">
          <Button
            onClick={() => {
              setFormData(null);
              setIsEditing(false);
              setIsModelOpen(true);
            }}
            icon={HiOutlinePlus}
            className="whitespace-nowrap"
            loading={loading}
          >
            New Foundry Log
          </Button>
        </div>
      </RegistryHeader>

      <div className="px-8 pt-0 pb-4 flex-1 overflow-hidden flex flex-col" data-tour="foundry-table">
        <div
          ref={tableScrollRef}
          className="relative overflow-auto border border-gray-200 bg-white flex-1 "
        >
          <div className="min-w-max">
            <Table
              columns={[
                { key: "castinG_NO", label: " CASTING NO", align: "center" },
                {
                  key: "castinG_DATE",
                  label: " CASTING DATE",
                  align: "center",
                  render: (value) => formatDate(value),
                },
                { key: "furnacE_NAME", label: " FURNACE", align: "center" },
                { key: "iN_CHARGE_ID", label: " IN CHARGE PERSON", align: "center" },
                { key: "remark", label: " REMARK", align: "center" },
              ]}
              data={isFoundryData}
              onEdit={(row) => handleEdit(row.castinG_NO)}
              onDelete={(row) => handleDelete(row.castinG_NO)}
              tableClassName="text-[12px] font-bold"
            />
          </div>
        </div>
      </div>

      <ConfirmDeleteModal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        onConfirm={handleConfirmDelete}
        loading={isSaving}
      />

      <TourGuide
        isOpen={isTourOpen}
        onClose={() => setIsTourOpen(false)}
        steps={Foundry_FoundryMasterTourSteps}
        onComplete={handleTourComplete}
      />
    </div>
  );
};

export default Foundry;
